import React from 'react';
import { Helmet } from "react-helmet";
import Reports from '../../Components/Reports/Reports';
import PrimarySearchAppBar from '../../Components/Layout/Header';
import Footer from '../../Components/Home/Footer'

function index() {
  return (
    <React.Fragment>
    <Helmet titleTemplate="PRSS | %s" title="Reports" />
<PrimarySearchAppBar/>
    <Reports />
    <Footer/>
  </React.Fragment>
  );
}

export default index;
